import { render, staticRenderFns } from "./DelayPolicyList.vue?vue&type=template&id=6cc0c7b0&scoped=true&"
import script from "./DelayPolicyList.vue?vue&type=script&lang=js&"
export * from "./DelayPolicyList.vue?vue&type=script&lang=js&"
import style0 from "./DelayPolicyList.vue?vue&type=style&index=0&id=6cc0c7b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_@vue+com_158fd1d6ef9e4cc6d0695d4cab9c983b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc0c7b0",
  null
  
)

export default component.exports